import { render, staticRenderFns } from "./PartnersTab.vue?vue&type=template&id=54bf5d80&scoped=true"
import script from "./PartnersTab.vue?vue&type=script&lang=js"
export * from "./PartnersTab.vue?vue&type=script&lang=js"
import style0 from "./PartnersTab.vue?vue&type=style&index=0&id=54bf5d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf5d80",
  null
  
)

export default component.exports